// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"619b30d2","366":"dd6f7e78","503":"d542da86","846":"131980f5"}[chunkId] + ".chunk.js";
};